//#region theme/frontend/islands/invert-overlay.js
var InvertOverlay = class extends HTMLElement {
	connectedCallback() {
		this._active = false;
		this._onKey = (e) => {
			if (e.key === "i" && !e.metaKey && !e.ctrlKey && !e.altKey) this._active ? this.deactivate() : this.activate();
		};
		document.addEventListener("keydown", this._onKey);
	}
	activate() {
		this._active = true;
		this.style.opacity = "1";
	}
	deactivate() {
		this._active = false;
		this.style.opacity = "0";
	}
	disconnectedCallback() {
		document.removeEventListener("keydown", this._onKey);
	}
};
customElements.define("invert-overlay", InvertOverlay);
//#endregion
